import moment from 'moment';

const custom = {
  fullname: value => {
    const regex = /^\s*[A-zÀ-ú]{2}[A-zÀ-ú|\s]*\s[A-zÀ-ú]{2,}\s*$/;

    return regex.test(value);
  },

  phone: value => {
    const regex = /^\(\d{2}\)\s\d{5}-\d{4}$/;

    return regex.test(value);
  },

  cep: value => {
    const regex = /^\d{5}-\d{3}$/;

    return regex.test(value);
  },

  date: value => {
    return moment(value, 'DD/MM/YYYY', true).isValid();
  },

  alpha_num_spaces: value => {
    const regex = /^([A-zÀ-ú]|\d|\s)*$/;

    return regex.test(value);
  }
};

export default custom;
